import { API_ENDPOINTS } from '@/constants';
import { apiRequest } from '@/services/client';

export type UpdateCurrentUserProfilePayload = {
  first_name: string;
  last_name: string;
  document_number: string;
  phone_number?: string | null;
};

export type UpdateCurrentUserPhotoPayload = {
  photo: string;
};

export const updateCurrentUserProfile = async (
  body: UpdateCurrentUserProfilePayload,
): Promise<void> => {
  await apiRequest<void>(API_ENDPOINTS.USERS.PROFILE.UPDATE, {
    method: 'PATCH',
    data: body,
    retry: { retries: 0 },
    useGlobalErrorHandler: false,
  });
};

export const updateCurrentUserPhoto = async (
  body: UpdateCurrentUserPhotoPayload,
): Promise<void> => {
  await apiRequest<void>(API_ENDPOINTS.USERS.PHOTO.UPDATE, {
    method: 'PATCH',
    data: body,
    retry: { retries: 0 },
    useGlobalErrorHandler: false,
  });
};

export const deleteCurrentUserPhoto = async (): Promise<void> => {
  await apiRequest<void>(API_ENDPOINTS.USERS.PHOTO.DELETE, {
    method: 'DELETE',
    retry: { retries: 0 },
    useGlobalErrorHandler: false,
  });
};
